import { SetTokenData } from "@/helper/userHelper";
import API from "@/service/index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { LoadingStatusType } from "../../enums/enums";

@Module({ namespaced: true })
export default class LineToken extends VuexModule {
  public lineTokenLoadingStatus = LoadingStatusType.None;
  public lineTokenValidate: boolean | null = null;
  public lineAuthData = null;
  public lineAccessToken = "";

  @Mutation
  public setLoading(lineAccessToken: string): void {
    this.lineTokenValidate = null;
    this.lineTokenLoadingStatus = LoadingStatusType.Loading;
    this.lineAccessToken = lineAccessToken;
  }

  @Mutation
  public setValidationSuccess(authData: any): void {
    this.lineTokenLoadingStatus = LoadingStatusType.Success;
    this.lineTokenValidate = true;
    this.lineAuthData = authData;
  }

  @Mutation
  public setValidationFail(): void {
    this.lineTokenLoadingStatus = LoadingStatusType.Fail;
    this.lineTokenValidate = false;
    this.lineAuthData = null;
  }

  @Action
  public LineTokenAutorize(token: string): void {
    this.context.commit("setLoading", token);
    const _input = {
      accessToken: token,
    };

    API.LineService.DoLineAuthorize(_input)
      .then((res: any) => {
        if (res.data.resCode == "200") {
          const authData = res.data.data;
          const tokenData = {
            accessToken: authData.accessToken,
            refreshToken: authData.refreshToken,
            userId: authData.userId,
            merchantId: authData.merchantId,
          };
          SetTokenData(tokenData);
          this.context.dispatch("UserInfo/DoGetUserInfo", undefined, { root: true });
          this.context.commit("setValidationSuccess", authData);
        } else {
          this.context.commit("setValidationFail");
        }
      })
      .catch((err: any) => {
        this.context.commit("setValidationFail");
      });
  }

  get getLineTokenLoadingStatus(): LoadingStatusType {
    return this.lineTokenLoadingStatus;
  }
  get getLineTokenValidate(): boolean | null {
    return this.lineTokenValidate;
  }
  get getLineAuthData(): any {
    return this.lineAuthData;
  }
  get getLineAccessToken(): string {
    return this.lineAccessToken;
  }
}
